<template>
  <div id="crew-labor">
    <page-layout-template />
  </div>
</template>

<script>
import PageLayoutTemplate from "./PageLayoutTemplate.vue";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapGetters, mapMutations } = createNamespacedHelpers("crewLabor");


export default {
  components: {
    PageLayoutTemplate,
  },
  data () {
    return {
    };
  },
  watch: {
    enterpriseCrewId (_) {
      this.SET_ENTERPRISE_CREW_ID(this.$route.params.id);
      this.fetchCrew();
    },
  },
  computed: {
    ...mapGetters(["enterpriseCrewLaborId"]),
    enterpriseCrewId () {
      return this.$route.params.id;
    },
  },
  methods: {
    ...mapMutations(["SET_ENTERPRISE_CREW_ID"]),
    ...mapActions(["fetchCrew"]),

  },
  created () {
  },
  async mounted () {
    this.SET_ENTERPRISE_CREW_ID(this.$route.params.id)
    await this.fetchCrew();
    if (!this.enterpriseCrewLaborId) return;
  },
};
</script>

<style lang="scss">
#crew-labor {
}
</style>
